import gql from "graphql-tag";

export default gql`query QuoteScheduleEmails($id:Int!) {
    quote(id:$id) {
        id
        quoteEmails {
          EMAIL_ID
          QUOTE_ID
          email {
            id
            address
            personal
          }
        }
        emailTemplates {
          id
          selectedByDefault
          emailTemplateRevision{
            id
            subject
            schedule
          }
          html(quoteid:$id)
        }
      }
  }`